"use client";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export default function IC_EN_08({ width, height }) {
  const { theme } = useTheme();
  const [color, setColor] = useState("#324ba6");

  useEffect(() => {
    setColor(theme === "dark" ? "#324BA6" : "#324ba6");
  }, [theme]);
  return (
    <svg
      id="Capa_1"
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      width={width}
      height={height}
    >
      <defs>
        <style>
          {`.cls-1 {
        stroke-width: 0px;
        fill: ${color};
      }`}
        </style>
      </defs>
      <path
        className="cls-1"
        d="m14.73,23.69c-.09,0-.17-.02-.25-.07-.23-.14-.3-.43-.16-.66l.92-1.51h-1.32c-.17,0-.33-.09-.42-.24-.09-.15-.08-.34,0-.48l1.3-2.18c.09-.15.24-.24.41-.24.09,0,.17.02.25.07.23.14.3.43.17.66l-.86,1.45h1.33c.17,0,.33.09.42.25.09.15.08.34,0,.49l-1.36,2.24c-.09.15-.24.23-.41.23Z"
      />
      <path
        className="cls-1"
        d="m3.68,28.17c-.24,0-.45-.18-.48-.42l-1.53-12.78H.48c-.27,0-.48-.22-.48-.48v-3.74c0-.27.22-.48.48-.48h1.67l1.07-3.27c.06-.2.25-.33.46-.33h4.94V2.31c0-.27.22-.48.48-.48h11.81c.27,0,.48.22.48.48v4.35h4.94c.21,0,.39.13.46.33l1.07,3.27h1.67c.27,0,.48.22.48.48v3.74c0,.27-.22.48-.48.48h-1.19l-1.53,12.78c-.03.24-.23.42-.48.42H3.68Zm18.9-.96h3.31l1.47-12.24h-2.98v3.02c0,.27-.22.48-.48.48h-1.32v8.74Zm-14.2,0h13.24v-8.74h-1.32c-.27,0-.48-.22-.48-.48v-3.02h-9.63v3.02c0,.27-.22.48-.48.48h-1.32v8.74Zm-4.27,0h3.31v-8.74h-1.32c-.27,0-.48-.22-.48-.48v-3.02h-2.98l1.47,12.24Zm16.67-9.7h2.64v-2.54h-2.64v2.54Zm-14.2,0h2.64v-2.54h-2.64v2.54ZM.96,14h28.08v-2.77H.96v2.77Zm21.48-3.74h4.4l-.87-2.64h-4.4l.87,2.64Zm-13.86,0h12.85l-.87-2.64h-11.11l-.87,2.64Zm-5.42,0h4.4l.87-2.64h-4.4l-.87,2.64Zm6.42-3.61h10.85v-3.87h-10.85v3.87Z"
      />
    </svg>
  );
}
